var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.3843 0.834248C13.0066 0.435929 12.3768 0.418386 11.9779 0.7971L5.62627 6.82072L2.59675 3.71024C2.21305 3.31657 1.58394 3.30795 1.18993 3.69169C0.796264 4.07506 0.787972 4.70484 1.17134 5.09851L4.88572 8.91206C5.08037 9.11204 5.33906 9.21284 5.59843 9.21284C5.84451 9.21284 6.0906 9.12196 6.28328 8.93991L13.3472 2.24078C13.7458 1.86269 13.7627 1.2329 13.3843 0.834248Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/Success.b102edd3e158267ec8be6f1856347d09.svg";
export { ForwardRef as ReactComponent };